// @ts-check

/**
 * @file Provides shared invoice group route helpers.
 */

const CARRIED_SEARCH_PARAMS = [
  "backendHost",
  "backendPort",
  "backendProtocol",
  "platform",
  "systemTest",
  "systemTestClientWsPort",
  "systemTestScoundrelPort"
]

export const TRANSLATIONS = {
  da: {
    empty: "Ingen fakturaer i gruppen",
    forbidden: "Du har ikke adgang til denne side",
    general: "Generelt",
    invoices: "Fakturaer",
    loading: "Indlæser fakturaer...",
    loadErrorPrefix: "Kunne ikke indlæse fakturaer",
    missingId: "Fakturagruppe-id mangler",
    notFound: "Fakturagruppen blev ikke fundet",
    notSignedIn: "Du skal logge ind for at fortsætte",
    titleFallback: "Fakturagruppe"
  },
  de: {
    empty: "Keine Rechnungen in dieser Gruppe",
    forbidden: "Sie haben keinen Zugriff auf diese Seite",
    general: "Allgemein",
    invoices: "Rechnungen",
    loading: "Rechnungen werden geladen...",
    loadErrorPrefix: "Rechnungen konnten nicht geladen werden",
    missingId: "Rechnungsgruppen-ID fehlt",
    notFound: "Die Rechnungsgruppe wurde nicht gefunden",
    notSignedIn: "Sie müssen sich anmelden, um fortzufahren",
    titleFallback: "Rechnungsgruppe"
  },
  en: {
    empty: "No invoices in this group",
    forbidden: "You do not have access to this page",
    general: "General",
    invoices: "Invoices",
    loading: "Loading invoices...",
    loadErrorPrefix: "Could not load invoices",
    missingId: "Invoice group id is missing",
    notFound: "Invoice group was not found",
    notSignedIn: "You must sign in to continue",
    titleFallback: "Invoice group"
  }
}

/**
 * Resolves the active document locale.
 * @returns {"da" | "de" | "en"} Active locale key.
 */
export function currentLocale() {
  if (typeof document == "undefined") {
    return "en"
  }

  const htmlLang = document.documentElement.lang.toLowerCase()

  if (htmlLang.startsWith("da")) {
    return "da"
  }

  if (htmlLang.startsWith("de")) {
    return "de"
  }

  return "en"
}

/**
 * Adds carried system-test query params to a route path.
 * @param {Record<string, string | string[] | undefined>} params Current query params.
 * @param {string} path Destination path.
 * @returns {string} Route path with carried params.
 */
export function routePathWithParams(params, path) {
  const url = new URL(path, "http://placeholder")

  for (const key of CARRIED_SEARCH_PARAMS) {
    const value = params[key]

    if (typeof value == "string" && value) {
      url.searchParams.set(key, value)
    }
  }

  const query = url.searchParams.toString()

  return query ? `${url.pathname}?${query}` : url.pathname
}
